import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Button as ReactStrapButton, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import styled from "styled-components"
import cloneDeep from "lodash/cloneDeep"
import { Button } from "../../themed-html-components"
import CheckBox from "../../inputs/Checkbox"

const IntroArea = styled.div`
  margin-bottom: 2em;
`

const CheckBoxArea = styled.div`
  margin-left: 2em;
`

const SelectAllArea = styled.div`
  margin-left: 2em;
`

class EmployeeDetailsSelectionModal extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    closePopup: PropTypes.func.isRequired,
    employeeDetailOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      selected: PropTypes.bool,
    })).isRequired,
    updateSelectedOptions: PropTypes.func.isRequired,
    selectedOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  }

  componentDidMount() {
    this.checkAutoSelectAllToggle()
  }

  PopulateOptions = (options, selectedOptions) => {
    return options.map((option) => {
      return {
        label: option.label,
        value: option.value,
        selected: selectedOptions.includes(option.value),
      }
    })
  }
  state = {
    employeeDetailOptions: this.PopulateOptions(
      cloneDeep(this.props.employeeDetailOptions),
      this.props.selectedOptions
    ),
    selectAllOption: {
        label: this.props.t("Common.SelectAll"),
        selected: false,
        value: 0
    },
  }

  onOptionChanged = (e) => {
    const newState = cloneDeep(this.state.employeeDetailOptions)
    const selectedValue = parseInt(e.target.value, 10)

    const currentItem = newState.find((item) => {
      return item.value === selectedValue
    })
    currentItem.selected = e.target.checked
    this.setState({ employeeDetailOptions: newState }, function() {
      this.checkAutoSelectAllToggle()
    })
  }

  selectAll = (e) => {
    // Take the checked or non checked value for use later.
    const selected = e.target.checked

    // Copy state object and apply new selected value, then update state.
    const selectAllNewState = cloneDeep(this.state.selectAllOption)
    selectAllNewState.selected = selected
    this.setState({ selectAllOption: selectAllNewState})
    
    // Create new state object based on options, then apply the new selected value, and 
    // update state.
    var newState = [...this.state.employeeDetailOptions];
    for (var i = 0; i < newState.length; i++) {
      newState[i].selected = selected
    }
    this.setState({ employeeDetailOptions: newState })
  }

  closeModal = () => {
    this.props.closePopup()
  }

  submitChanges = () => {
    this.props.updateSelectedOptions(this.state.employeeDetailOptions)
  }
  checkAutoSelectAllToggle = () => {
    // Check to see if all options have been selected manually.
    var toggleSelectAll = true
    for (var i = 0; i < this.state.employeeDetailOptions.length; i++) {
      if (this.state.employeeDetailOptions[i].selected == false) {
        toggleSelectAll = false        
      }
    }

    // If that is the case then we want to auto toggle the select all option,
    // so that all the options can be deselected easily.
    const selectAllNewState = cloneDeep(this.state.selectAllOption)
    selectAllNewState.selected = toggleSelectAll
    this.setState({ selectAllOption: selectAllNewState})
  }
  render() {
    const { t } = this.props

    return (
      <Modal isOpen toggle={this.closeModal} className="modal-md">
        <ModalHeader toggle={this.closeModal}>
          {t("CustomReport.EmployeeDetailsSelection.ModalTitle")}
        </ModalHeader>
        <ModalBody>
          <IntroArea>
            <em>{t("CustomReport.EmployeeDetailsSelection.ModalIntro")}</em>
          </IntroArea>
          <SelectAllArea>
            <CheckBox
                    labelText={this.state.selectAllOption.label}
                    checked={this.state.selectAllOption.selected}
                    onChangeHandler={this.selectAll}
                    value={this.state.selectAllOption.value.toString()}    
                    displayInModal 
                    closerCheckboxLabel               
                  />
          </SelectAllArea>
          <CheckBoxArea>
            {this.state.employeeDetailOptions.map((option, i) => {
              return (
                <Fragment>
                  <CheckBox
                    key={option.value}
                    labelText={option.label}
                    checked={option.selected ? option.selected : false}
                    onChangeHandler={this.onOptionChanged}
                    value={option.value.toString()}
                    displayInModal
                  />
                  {i < (this.state.employeeDetailOptions.length - 1) &&
                    <hr className="col-lg-10 col-md-10" style={{ marginLeft: "0px", marginTop: "0px", marginBottom: "10px" }} />
                  }
                </Fragment>
              )
            })}
          </CheckBoxArea>
        </ModalBody>
        <ModalFooter>
          <Button inverted onClick={this.submitChanges}>
            {t("Common.Submit")}
          </Button>{" "}
          <ReactStrapButton color="secondary" onClick={this.closeModal}>
            {t("Common.Cancel")}
          </ReactStrapButton>
        </ModalFooter>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
    reportSelection: state.reportSelection,
  }
}

export default compose(translate(), connect(mapStateToProps))(EmployeeDetailsSelectionModal)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/EmployeeDetailsSelectionModal.jsx